import SmallHeader from './SmallHeader';
export default SmallHeader;
